import gql from 'graphql-tag';

export const AdmissionRoundFragment = gql`
  fragment AdmissionRoundFragment on AdmissionRound {
    id
    roundNo
    subRoundNo
    seats
    seatsDisplayText
    projectName
    displayName
    url
    applicationDate {
      startDate
      endDate
    }
    details {
      title
      listv2 {
        title
        indentLevel
      }
      displayType
    }
    updatedAt
  }
`;

export const AdmissionRoundExamRequiredFragment = gql`
  fragment AdmissionRoundExamRequiredFragment on AdmissionRound {
    id
    roundNo
    subRoundNo
    projectName
    requiredExams {
      id
      weightPercent
      examsDisplay
      examsSubDisplay
    }
    updatedAt
  }
`;

export const AdmissionRoundExamRequiredDetailFragment = gql`
  fragment AdmissionRoundExamRequiredDetailFragment on AdmissionRound {
    id
    ...AdmissionRoundExamRequiredFragment
    requiredExams {
      id
      rule
      minScoreFix
      minScorePercent
      multiplier
      exams {
        id
        name
        ordering
        fullScore
      }
      remarks
    }
    requiredExamsSpec {
      id
      canCalculate
      fullScore
      multiplier
      decimalPoint
    }
    updatedAt
  }
  ${AdmissionRoundExamRequiredFragment}
`;
